import { isFirefox } from "react-device-detect";
import TOKENS from "../../tokens/tokens";
const { dark } = TOKENS.theme;
const DION_SCROLLBAR = {
  // в ФФ не поддерживается кастомизация скроллбара через ::-webkit-scrollbar-*
  scrollbarColor: isFirefox ? "var(--mui-palette-dionCommon-transparent) transparent" : "unset",
  scrollbarWidth: isFirefox ? "thin" : "unset",
  // ----------------------------------------------------------------------------------------------
  "&::-webkit-scrollbar": {
    width: `${dark.scroll.size.m}px`,
    height: `${dark.scroll.size.m}px`,
    backgroundColor: "transparent"
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "var(--mui-palette-dionCommon-transparent)",
    //dark.color.common.transparent,
    borderRadius: dark.radius.m
  },
  "&::-webkit-scrollbar-track": {
    // marginTop: '16px',
    // marginBottom: '16px',
  },
  "&::-webkit-scrollbar-track-piece:start": {
    background: "transparent",
    marginTop: "8px"
  },
  "&::-webkit-scrollbar-track-piece:end": {
    background: "transparent",
    marginBottom: "8px"
  }
};
export {
  DION_SCROLLBAR
};
